module.exports = __webpack_public_path__ + "static/media/Samsung.27d93b7d.png";